/* eslint-disable no-undef */
export default {
  init() {
    // JavaScript to be fired on the about us page

    var canBeLoaded = true, // this param allows to initiate the AJAX call only if necessary
      bottomOffset = 2000;

    $(window).on("scroll", function () {
      var data = {
        action: "loadmore",
        query: journal_loadmore_params.posts,
        page: journal_loadmore_params.current_page,
      };
      if (
        $(document).scrollTop() > $(document).height() - bottomOffset &&
        canBeLoaded == true
      ) {
        $.ajax({
          url: journal_loadmore_params.ajaxurl,
          data: data,
          type: "POST",
          beforeSend: function () {
            // you can also add your own preloader here
            // you see, the AJAX call is in process, we shouldn't run it again until complete
            canBeLoaded = false;
          },
          success: function (data) {
            if (data) {
              $(".journal--grid").append(data); // where to insert posts
              canBeLoaded = true; // the ajax is completed, now we can run it again
              journal_loadmore_params.current_page++;
            }
          },
        });
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/blog.js